module.exports = __webpack_public_path__ + "img/logboek-liaan-verticaal.0ffeaa53.png";